import {sendReport} from "../actions";
import {call, select, takeEvery} from "redux-saga/effects";
import {ActionType, getType} from "typesafe-actions";
import apiCall from "../../../shared/utils/apiCall";
import {exportStateFlow} from "../stateFlowEnhancer";
import {IApplicationState} from "../../index";
import { SDK } from "../../../sdk";

export default function* reportProblemWorker() {
    const {appVersion} = yield select(({ player, settings }: IApplicationState) => ({
        appVersion: settings.appVersion,
        userId: settings.userId || "_" + player.id,
    }));

    yield takeEvery(getType(sendReport), function* ({ payload: report }: ActionType<typeof sendReport>) {
        const flow = yield call(exportStateFlow);

        yield apiCall({
            params: {
                section: "report",
                method: "post",
            },
            data: {
                ...report,
                clientData: {
                    appVersion: appVersion,
                    clientTime: new Date().getTime(),
                    state: flow,
                    storeVendor: SDK.instance.name,
                    supportedApis: SDK.instance.supports,
                }
            }
        });
    });
}